import { render, staticRenderFns } from "./CopySeasonRoutes.vue?vue&type=template&id=9f50489c&"
import script from "./CopySeasonRoutes.vue?vue&type=script&lang=js&"
export * from "./CopySeasonRoutes.vue?vue&type=script&lang=js&"
import style0 from "./CopySeasonRoutes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports